<script>
    import {getAuth} from "../../config/firebase-config";
    import {user} from "./admin-store";
    import TextInput from "../../components/ui/TextInput.svelte";
    import Form from "../../components/ui/Form.svelte";
    import {createFailureMsg} from "../../config/database-repo";
    import AlertMessage from "../../components/ui/AlertMessage.svelte";

    let username;
    let password;
    let message;

    function onUserNameChange({target: {value}}) {
        username = value;
    }

    function onPasswordChange({target: {value}}) {
        password = value;
    }

    const onFormSubmit = () => {
        getAuth().signInWithEmailAndPassword(username, password)
            .then(userCredential => {
                user.set(userCredential.user.email)
                sessionStorage.setItem('signed', $user);
            })
            .catch(error => {
                console.log(error.message);
                message = createFailureMsg('Wrong credentials!');
            });
    };

    const clearForm = () => {
        username = password = '';
    };

    function focus(node) {
        node.focus();
    }
</script>

<!--------------------------------------------------------------------------------------------------------------------->
<AlertMessage {message}/>
<Form on:clear={clearForm} on:submit={onFormSubmit}>
    <TextInput label="username" value={username} on:input={onUserNameChange} />
    <TextInput label="password" type="password" value={password} on:input={onPasswordChange} />
</Form>

<!--------------------------------------------------------------------------------------------------------------------->
